import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const token = () => localStorage.getItem('streamToken') || '';

class InvoiceService {
  // ---- current user ----
  static async myInvoices() {
    const { data } = await api.get('/invoices');
    return data.data || [];
  }
  static invoicePdfUrl(id) {
    return `${API_URL}/invoices/${id}/pdf?token=${encodeURIComponent(token())}`;
  }
  static invoiceHtmlUrl(id) {
    return `${API_URL}/invoices/${id}/html?token=${encodeURIComponent(token())}`;
  }
  static async getInvoice(id) {
    const { data } = await api.get(`/invoices/${id}`);
    return data.data;
  }

  // ---- admin ----
  static async adminList(params = {}) {
    const { data } = await api.get('/invoices/admin', { params });
    return data.data; // { invoices, stats }
  }
  static async getCompany() {
    const { data } = await api.get('/invoices/admin/company');
    return data.data; // { company, auto_enabled }
  }
  static async updateCompany(payload) {
    const { data } = await api.put('/invoices/admin/company', payload);
    return data.data;
  }
  static async createManual(payload) {
    const { data } = await api.post('/invoices/admin', payload);
    return data.data;
  }
  static async update(id, payload) {
    const { data } = await api.put(`/invoices/admin/${id}`, payload);
    return data.data;
  }
  static async send(id) {
    const { data } = await api.post(`/invoices/admin/${id}/send`);
    return data;
  }
  static async markPaid(id) {
    const { data } = await api.post(`/invoices/admin/${id}/mark-paid`);
    return data.data;
  }
  static async voidInvoice(id) {
    const { data } = await api.post(`/invoices/admin/${id}/void`);
    return data.data;
  }
  static async remove(id) {
    await api.delete(`/invoices/admin/${id}`);
  }
}

export default InvoiceService;
